import { safeReturnTo } from './config';

/** Redirect safe Orca DEV entry routes to the registered loopback callback origin. */
export function canonicalizeDevEntry(
  href: string,
  isDevelopment: boolean,
  redirectUri: string | undefined,
): string | null {
  if (!isDevelopment || !redirectUri) return null;
  try {
    const url = new URL(href);
    const callback = new URL(redirectUri);
    if (
      callback.href !== 'http://localhost:3000/auth/callback' ||
      url.protocol !== 'http:' ||
      !url.hostname.endsWith('.orca.localhost') ||
      url.username ||
      url.password ||
      url.hash ||
      [
        'code',
        'state',
        'error',
        'error_description',
        'access_token',
        'refresh_token',
        'id_token',
      ].some((key) => url.searchParams.has(key))
    )
      return null;
    const path =
      url.pathname === '/' && !url.search
        ? '/'
        : url.pathname === '/login'
          ? (() => {
              const values = url.searchParams.getAll('returnTo');
              if (values.length > 1) throw new Error('Invalid login return path');
              const returnTo = values[0] ? safeReturnTo(values[0]) : undefined;
              const search = new URLSearchParams();
              if (returnTo) search.set('returnTo', returnTo);
              return `/login${search.size ? `?${search}` : ''}`;
            })()
          : safeReturnTo(`${url.pathname}${url.search}`);
    return new URL(path, callback.origin).href;
  } catch {
    return null;
  }
}
